import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { RiLoader4Line } from "react-icons/ri";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Progress } from "../ui/progress";

export default function AlertCompanyLoading({
  progress,
  className,
}: {
  progress: number;
} & React.HTMLAttributes<HTMLDivElement>) {
  const { t } = useTranslation();

  return (
    <Alert variant="default" className={cn(className)}>
      <AlertTitle className="py-1 text-xs">
        <RiLoader4Line className="inline-block mr-2 w-4 h-4 animate-spin" />
        {t("company.alerts.loading")} {progress}%
      </AlertTitle>
      <AlertDescription>
        <Progress value={progress} className="my-3" />
      </AlertDescription>
    </Alert>
  );
}
